import { Box, styled } from "@mui/material";

export const InfoRow = styled(Box)`
  display: flex;
  gap: 10px;
  align-items: center;
`;
